import React from 'react'
import data from '../../../database/events.json'
import { Link } from 'react-router-dom';
import { viewportBreakpoint, useViewport } from '../../../utils';

const ListItem = ({data, index}) => {
  const backgroundColor = index % 2 === 1 ? '#fff' : '#f9f9f9';
  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet
  const size = isMobile ? '73px' : '80px'

  return (
    <div className="w-full px-5 py-4 lg:py-5 relative" style={{background: backgroundColor}}>
      <div className="flex">
        <div
          style={{minWidth: size, height: size, backgroundImage: `url('${data.image}')`}}
          className="rounded mr-4 lg:mr-5 bg-cover bg-no-repeat bg-center"
        />
        <div>
          <h1 className="font-primary font-bold mb-2 lg:w-10/12">{data.title}</h1>
          <div className="text-xs leading-tight text-gray-999 mb-3 lg:mb-0">
            <p>{data.date}</p>
            <p className="mb-1 lg:mb-2">{data.note}</p>
            <p>{data.organization}</p>
          </div>
          <div className="link lg:absolute top-0 right-0 lg:p-5">
            <Link className="text-xs lg:text-sm" to="/dashboard/tickets/detail">See Details</Link>
          </div>
        </div>
      </div>
    </div>
  )
}

const List = () => {
  return (
    <div className="list mb-8 lg:mb-0">
      {
        data.slice(0, 3).map((d, index) => (
          <ListItem key={index} data={d} index={index}/>
        ))
      }
    </div>
  )
}

export { List }
